export { default } from './LeilaoDeVeiculosBlog';
